module.exports = __webpack_public_path__ + "static/media/invoice 8.b2a4d6bd.svg";